<template>
	<div class="page-mdl">
		<!-- 搜索 -->
		<div class="search-wrap">
			<div class="search-main">
				<div class="search-box">
					<input class="input" type="text" placeholder="输入教师名称搜索">
					<span class="btn">搜索</span>
				</div>
			</div>
		</div>
		
		<!-- 教师列表 -->
		<div class="teacher-wrap w1200">
			<div class="teacher-item" v-for="(item2,index2) in [1,2,3,4]" :key="index2">
				<div class="box">
					<img class="pic" src="../../static/img/temp/1.png" alt="">
					<div class="info">
						<h3 class="name">王源</h3>
						<div class="label">江西师范大学  |  教授 博导</div>
						<div class="des">江西省廉政文化研究中心副主任、江西省省级协同创新中心“社会发展与治理研究中心”副主任、江西省政治学会副会长。江西省思想政治理论课名师、江西省中青年学科带头人、南昌大学兼职研究员、井冈山.......</div>
						<a class="more" href="javascript:;">查看该老师更多课程</a>
					</div>
				</div>
				<ul class="course-list">
					<li v-for="(item,index) in [1,2]" :key="index" >
						<div class="label" :class="{green:index==0,orange:index==1}">联盟精品课</div>
						<img class="img" src="../../static/img/temp/1.png" alt="">
						<div class="info">
							<h3>金融衍生品设计与风险管理虚拟仿真实验</h3>
							<div class="center">
								<p>南昌大学 | 刘玉</p>
								<span>2022春</span>
							</div>
						</div>
						<div class="btm">
							<span class="status" :class="{gray:index==2,orange:index==3}">开课中</span>
							<span class="learn-num">1082人已学</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	data () {
		return {
			
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		
	},
  
	computed:{
		
	},
  
	methods:{
		
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-course.less';
.teacher-wrap{
	padding-bottom:60px;
	.teacher-item{
		display:flex; padding:40px 0; border-bottom:1px solid #EEEEEE;
		&:last-child{ border-bottom:none; }
		.box{
			width:590px; height:330px; box-sizing: border-box; padding:20px; background: #F7F8FA; 
			border-radius: 4px; border: 1px solid #EEEEEE;  display:flex; margin-right:20px;
			.pic{ width:218px; height:290px; margin-right:20px; }
			.info{
				flex:1; padding-top:10px;
				.name{ font-size:20px; color:#333333; font-weight: bold; line-height:20px; margin-bottom:12px; }
				.label{ font-size: 14px; line-height:16px; color:#999999; margin-bottom:12px;}
				.des{ 
					font-size: 16px; line-height:26px; color:#666666; height:130px; margin-bottom:70px; overflow: hidden;
					overflow : hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical; 
				}
				.more{ 
					display:inline-block; font-size:14px; line-height:16px; height:16px; color:#1677FF; position:relative; padding-right:16px;
					&::after{
						content:''; display:inline-block; width:10px; height:10px; 
						background:url('../../static/img/ico-tri2.png') right center;  background-size: 10px 10px;
						position:absolute; right:0; top:50%; margin-top:-5px;
					}
					&:hover{ text-decoration: underline; }
				 }
			}
		}
		.course-list{
			flex:1;
			li:nth-child(2){ margin-right:0; }
		}
	}
}


</style>



// WEBPACK FOOTER //
// src/pages/teacher-list/tpl-pc.vue